/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import { decorate, observable, action } from "mobx";
import { toasterState } from "Components/common/toaster";
import { makeApi, URLS } from "Utils/apiURL";
import { dialerStoreData } from "Stores/DialerData";
import axios from "axios";

let cancelTokenRequest = null;

export const defaultDialerOption = {
  mute: false,
  record: false,
  call: false,
  notes: false,
  keypad: true
};

class DialerServiceStore {
  // Observables
  dialerTokenObj = null;
  voBizTokenObj = null;
  dialerDefaultNo = null;
  voBizDefaultNo = null;
  voBizPhoneList = null;
  dialerOption = { ...defaultDialerOption };
  dialerPhoneList = null;
  dialerCallLogs = false;
  dialerCallNotes = "";
  dialerCallStatus = "";
  dialerBtnLoader = false;
  dialerCallProgress = false;
  dialerIvrKeypad = false;
  callRecordingEnabled = true;
  purchasedNumbers = [];
  deviceStatus = "";
  showCallLogPopup = false;
  callLogAiNotes = null;
  callLogAiNotesLoading = false;
  callDurationSeconds = 0;
  endCallRequested = false;

  // Cancel Request Function

  cancelTokenHttpRequest = () => {
    if (cancelTokenRequest !== null) {
      cancelTokenRequest("cancel");
      cancelTokenRequest = null;
    }
  };

  cancelTokenCallBack = value => {
    cancelTokenRequest = value;
  };

  // Action
  setDialerTokenObj = value => {
    this.dialerTokenObj = value;
  };

  setVoBizTokenObj = value => {
    this.voBizTokenObj = value;
  };

  setDialerCallLogs = value => {
    this.dialerCallLogs = value;
  };

  setDialerOption = (obj = {}) => {
    this.dialerOption = { ...this.dialerOption, ...obj };
  };

  setDialerCallNotes = value => {
    this.dialerCallNotes = value;
  };

  setDialerCallStatus = value => {
    this.dialerCallStatus = value;
  };

  setDialerDefaultNo = value => {
    this.dialerDefaultNo = value;
  };

  setDialerStartTimer = value => {
    this.dialerCallProgress = value;
  };

  setDialerIvrKeypad = value => {
    this.dialerIvrKeypad = value;
  };

  setCallRecordingEnabled = value => {
    this.callRecordingEnabled = value;
  };

  setPurchasedNumbers = value => {
    this.purchasedNumbers = value;
  };

  setDeviceStatus = (value = "") => {
    this.deviceStatus = value;
  };

  setShowCallLogPopup = (value = false) => {
    this.showCallLogPopup = value;
  };

  setCallDurationSeconds = (value = 0) => {
    this.callDurationSeconds = value;
  };

  setEndCallRequested = (value = false) => {
    this.endCallRequested = value;
  };

  setCallLogAiNotes = (value = null) => {
    this.callLogAiNotes = value;
  };

  fetchCallLogAiNotes = async (callSid = "") => {
    if (!callSid) return;
    this.callLogAiNotesLoading = true;
    this.callLogAiNotes = null;
    try {
      const config = { url: `${URLS.generateAiCallNotes}?callSid=${callSid}`, method: "GET" };
      const res = await makeApi(config);
      const { data = {} } = res || {};
      if (data?.responseCode === 200 && data?.aiNotes?.aiNotes) {
        this.callLogAiNotes = data.aiNotes.aiNotes;
      }
    } catch (e) {
      // silent fail — don't block call logging
    } finally {
      this.callLogAiNotesLoading = false;
    }
  };

  getVoBizToken = async () => {
    try {
      console.log("[VoBiz] getVoBizToken: calling", URLS.getVoBizToken);
      const config = { url: URLS.getVoBizToken, method: "GET" };
      let res = await makeApi(config);
      const data = res?.data;
      console.log("[VoBiz] getVoBizToken: response", JSON.stringify(data));

      if (data?.statusCode === "SUCCESS") {
        console.log("[VoBiz] getVoBizToken: SUCCESS sipUsername=", data.sipUsername);
        this.voBizTokenObj = data;
      } else {
        console.error("[VoBiz] getVoBizToken: non-SUCCESS response:", data?.statusCode, "httpStatus:", res?.status);
        toasterState.setToastMsg("Could not initialize India calling. Please try again.", "failure");
      }
      return data; // Always return so callers can inspect statusCode
    } catch (err) {
      console.error("[VoBiz] getVoBizToken: exception", err);
      return null;
    }
  };

  getVoBizPhoneNumbers = async () => {
    try {
      const config = { url: URLS.getVoBizPhoneNumbers, method: "GET" };
      let res = await makeApi(config);
      if (res?.data && res.data.statusCode === "SUCCESS") {
        const { defaultPhNumber = "purchaseNumber", phoneNumbers = [] } = res.data;
        this.voBizDefaultNo = defaultPhNumber || "purchaseNumber";
        this.voBizPhoneList = phoneNumbers
          .filter(p => p && (p.number || typeof p === "string"))
          .map(p => typeof p === "string" ? { number: p, configured: false } : p);
      }
    } catch (err) {
      console.error("Getting VoBiz phone numbers error", err);
    }
  };

  updateVoBizDefaultPhoneNumber = async data => {
    try {
      let config = {
        url: URLS.updateVoBizDefaultPhoneNumber,
        method: "PUT",
        data
      };
      let res = await makeApi(config);
      if (res?.data?.status === "200") {
        toasterState.setToastMsg(
          "Default India number updated successfully",
          "success"
        );
        this.voBizDefaultNo = data.ph_number;
      } else {
        toasterState.setToastMsg("Failed to update default India number", "failure");
      }
    } catch (err) {
      console.error("Update VoBiz default phone number error", err);
    }
  };

  getDailerToken = async (useTelnyx = false) => {
    try {
      let url = URLS.getDailerToken;
      if (useTelnyx) {
        url += "?useTelnyx=true";
      }
      const config = {
        url: url,
        method: "GET"
      };
      this.cancelTokenHttpRequest();
      let res = await makeApi(config, this.cancelTokenCallBack);
      if (res?.data && Object.keys(res.data).length > 0) {
        this.dialerTokenObj = res.data;
      } else {
        toasterState.setToastMsg(
          "Something went wrong. Please try again later",
          "failure"
        );
      }
    } catch (err) {
      console.error("Getting Dailer Token Error", err);
    }
  };


  getDialerPhoneList = async (isInit = true) => {
    try {
      const config = {
        url: URLS.getMyPhoneNumbers,
        method: "GET"
      };
      let res = await makeApi(config);
      if (res?.data && Object.keys(res.data).length > 0) {
        const { defaultPhNumber = "purchaseNumber", phoneNumbers = [] } =
          res.data || {};
        this.dialerDefaultNo = defaultPhNumber || "purchaseNumber";
        this.setDialerPhoneList(phoneNumbers || []);
        dialerStoreData.setMyPhoneNumbers(res?.data);
        this.updatePurchasedNumber(phoneNumbers);
      } else {
        if (isInit) {
          toasterState.setToastMsg(
            "Something went wrong. Please try again later",
            "failure"
          );
        }
      }
    } catch (err) {
      console.error("Getting Dailer Phone List Error", err);
    }
  };

  updateDefaultPhoneNumber = async data => {
    try {
      let config = {
        url: URLS.updateDefaultPhoneNumber,
        method: "PUT",
        data
      };
      let res = await makeApi(config);
      if (res?.data?.status === "200") {
        toasterState.setToastMsg(
          "Default Phone number updated successfully",
          "success"
        );
        this.dialerDefaultNo = data.ph_number;
      } else {
        dialerStoreData.showResponseMessage(res);
      }
      this.dialerBtnLoader = false;
    } catch (err) {
      console.error("Update default phone number error ", err);
    }
  };

  setDialerPhoneList = list => {
    if (list) {
      const tempArr = [];
      list.map(value => {
        if (value && value.number) {
          tempArr.push(value.number);
        }
      });
      this.dialerPhoneList = tempArr;
    }
  };

  updatePurchasedNumber = numberList => {
    const purchasedList = [];
    numberList?.length > 0 &&
      numberList.map(number => {
        const { numberType = "" } = number || {};
        if ("Purchased" === numberType) {
          purchasedList.push(number);
        }
      });
    this.setPurchasedNumbers(purchasedList);
  };

  // -------------------------------------------------------------------------
  // VoBiz Subaccount — Feature 1
  // -------------------------------------------------------------------------

  createVoBizSubAccount = async () => {
    try {
      const config = { url: URLS.voBizAddSubAccount, method: "GET" };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS") {
        console.log("[VoBiz] subaccount created/exists subAuthId=", res.data.subAccountAuthId);
      } else {
        console.warn("[VoBiz] createVoBizSubAccount: non-SUCCESS", res?.data);
      }
    } catch (err) {
      console.error("[VoBiz] createVoBizSubAccount error", err);
    }
  };

  // -------------------------------------------------------------------------
  // VoBiz Number Management — Feature 2
  // -------------------------------------------------------------------------

  getAvailableIndiaNumbers = async (pattern = "") => {
    try {
      const url = pattern
        ? `${URLS.voBizAvailableNumbers}?pattern=${encodeURIComponent(pattern)}`
        : URLS.voBizAvailableNumbers;
      const res = await makeApi({ url, method: "GET" });
      if (res?.data?.statusCode === "SUCCESS") {
        return res.data.numbers || [];
      }
      return [];
    } catch (err) {
      console.error("[VoBiz] getAvailableIndiaNumbers error", err);
      return [];
    }
  };

  purchaseIndiaNumber = async (phoneNumber, cost = 0, aadhaar = {}) => {
    try {
      const config = {
        url: URLS.voBizPurchaseNumber,
        method: "POST",
        data: { phoneNumber, cost: String(cost), ...aadhaar }
      };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS") {
        toasterState.setToastMsg("India number purchased successfully!", "success");
        await this.getVoBizPhoneNumbers();
        return { success: true };
      } else if (res?.data?.statusCode === "CREDITS_INSUFFICIENT") {
        return { success: false, creditsInsufficient: true, available: res.data.available, required: res.data.required };
      } else {
        const msg = res?.data?.message || "Failed to purchase number. Please try again.";
        toasterState.setToastMsg(msg, "failure");
        return { success: false };
      }
    } catch (err) {
      console.error("[VoBiz] purchaseIndiaNumber error", err);
      toasterState.setToastMsg("Something went wrong. Please try again.", "failure");
      return false;
    }
  };

  releaseIndiaNumber = async phoneNumber => {
    try {
      const config = {
        url: URLS.voBizReleaseNumber,
        method: "POST",
        data: { phoneNumber }
      };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS") {
        toasterState.setToastMsg("India number released successfully", "success");
        await this.getVoBizPhoneNumbers();
        return true;
      } else {
        const msg = res?.data?.message || "Failed to release number. Please try again.";
        toasterState.setToastMsg(msg, "failure");
        return false;
      }
    } catch (err) {
      console.error("[VoBiz] releaseIndiaNumber error", err);
      toasterState.setToastMsg("Something went wrong. Please try again.", "failure");
      return false;
    }
  };

  linkIndiaNumberToVoiceApp = async phoneNumber => {
    try {
      const config = {
        url: URLS.voBizLinkNumber,
        method: "POST",
        data: { phoneNumber }
      };
      const res = await makeApi(config);
      if (res?.data?.statusCode === "SUCCESS") {
        toasterState.setToastMsg("Number configured successfully!", "success");
        await this.getVoBizPhoneNumbers();
        return true;
      } else {
        const msg = res?.data?.message || "Failed to configure number. Please try again.";
        toasterState.setToastMsg(msg, "failure");
        return false;
      }
    } catch (err) {
      console.error("[VoBiz] linkIndiaNumberToVoiceApp error", err);
      toasterState.setToastMsg("Something went wrong. Please try again.", "failure");
      return false;
    }
  };

}

decorate(DialerServiceStore, {
  dialerTokenObj: observable,
  voBizTokenObj: observable,
  dialerOption: observable,
  dialerPhoneList: observable,
  voBizPhoneList: observable,
  dialerCallLogs: observable,
  dialerCallNotes: observable,
  dialerDefaultNo: observable,
  voBizDefaultNo: observable,
  dialerCallStatus: observable,
  dialerBtnLoader: observable,
  dialerCallProgress: observable,
  dialerIvrKeypad: observable,
  deviceStatus: observable,
  callRecordingEnabled: observable,
  purchasedNumbers: observable,
  showCallLogPopup: observable,
  callLogAiNotes: observable,
  callLogAiNotesLoading: observable,
  callDurationSeconds: observable,
  endCallRequested: observable,
  setDialerTokenObj: action,
  setVoBizTokenObj: action,
  getDailerToken: action,
  getVoBizToken: action,
  getVoBizPhoneNumbers: action,
  updateVoBizDefaultPhoneNumber: action,
  createVoBizSubAccount: action,
  getAvailableIndiaNumbers: action,
  purchaseIndiaNumber: action,
  releaseIndiaNumber: action,
  setDialerOption: action,
  getDialerPhoneList: action,
  updateDefaultNumber: action,
  setDialerCallLogs: action,
  setDialerCallNotes: action,
  setDialerCallStatus: action,
  setDialerDefaultNo: action,
  setDialerStartTimer: action,
  setDialerIvrKeypad: action,
  setDialerPhoneList: action,
  setDeviceStatus: action,
  setCallRecordingEnabled: action,
  setPurchasedNumbers: action,
  setShowCallLogPopup: action,
  setCallLogAiNotes: action,
  fetchCallLogAiNotes: action,
  setCallDurationSeconds: action,
  setEndCallRequested: action
});

const DialerServiceData = new DialerServiceStore();
export default DialerServiceData;
export { DialerServiceData };
